import { Box, IconButton, Stack } from "@mui/material";
import { Fragment, useMemo } from "react";
import { Close } from "@mui/icons-material";
import { useFormContext } from "react-hook-form";
import FormControlAutocomplete from "src/components/shared/FormControlAutocomplete";
import FormControlInput from "src/components/shared/FormControlInput";

const OrderProductForm = ({
  index,
  disabled = false,
  inventoryOptions = [],
  inventoryData = [],
  onProductSearchChange,
  inventoryLoading = false,
  inventoryLoadingMore = false,
  inventoryHasMore = false,
  onLoadMoreInventory,
}) => {
  const form = useFormContext();
  const orderDetails = form.watch("orderDetails");
  const productDetail = form.watch(`orderDetails.${index}.prod`);

  const productModelOptions = useMemo(() => {
    const productModel = inventoryData?.find((v) => v?._id === productDetail?.value);
    return (
      productModel?.productModels?.map((v) => ({
        ...v,
        label: v?.name,
        value: v?._id,
        qty: v?.qty,
      })) || []
    );
  }, [productDetail, inventoryData]);

  return (
    <Fragment>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        {orderDetails.length > 1 && !disabled && (
          <IconButton
            onClick={() =>
              form.setValue(
                "orderDetails",
                orderDetails.filter((_, i) => i !== index),
              )
            }
          >
            <Close sx={{ fontSize: "18px" }} />
          </IconButton>
        )}
      </Box>
      <FormControlAutocomplete
        name={`orderDetails.${index}.prod`}
        label="Sản phẩm"
        options={inventoryOptions}
        placeholder="Sản phẩm"
        loading={inventoryLoading}
        hasMore={inventoryHasMore}
        loadingMore={inventoryLoadingMore}
        onLoadMore={onLoadMoreInventory}
        filterOptions={(opts) => opts}
        onInputChange={(_, value, reason) => {
          if (reason === "input") onProductSearchChange?.(value);
          if (reason === "clear") onProductSearchChange?.("");
        }}
        onChange={(value) => {
          if (value) onProductSearchChange?.("");
          form.setValue(`orderDetails.${index}.productModel`, null);
        }}
        required
        disabled={disabled}
      />
      <FormControlAutocomplete
        name={`orderDetails.${index}.productModel`}
        label="Dung tích"
        options={productModelOptions}
        getOptionLabel={(option) => option?.label + ` (Tồn kho khả dụng: ${option?.lockQty ? option?.qty - option?.lockQty : option?.qty})`}
        placeholder="Dung tích"
        required
        disabled={disabled}
      />
      <Stack
        direction="row"
        gap="12px"
      >
        <FormControlInput
          name={`orderDetails.${index}.qty`}
          label="Số lượng"
          placeholder="Số lượng"
          type="number"
          required
          disabled={disabled}
        />
        <FormControlInput
          name={`orderDetails.${index}.discount`}
          label="Chiết khấu (%)"
          placeholder="Chiết khấu"
          type="number"
          required
          disabled={disabled}
        />
      </Stack>
    </Fragment>
  );
};

export default OrderProductForm;
